import store from '@/store'
import { QcqCommonGridItem, UiLanguageItem, UiLanguageList } from '@/types'
import { CompetenceResponse, CompetenceResponseItem } from '@/types/service-response'

export interface CompetenceItem {
  id: number
  code: string
  description: string
}

export class Competence {
  private constructor (
    readonly dataMap: Map<string, CompetenceItem>
  ) {}

  get commonGridData (): QcqCommonGridItem {
    const selectedUiLanguage: UiLanguageItem | undefined = store.state.selectedUiLanguage
    const value = this.dataMap.get(selectedUiLanguage!.code)
    const newItem: QcqCommonGridItem = {
      id: value!.id,
      code: value!.code,
      description: value!.description,
    }
    return newItem!
  }

  static createListFromResponse (responseData: CompetenceResponse): Array<Competence> {
    const competenceList: Array<Competence> = []
    let result: Map<number, Array<CompetenceResponseItem>> = new Map()
    const languageList: UiLanguageList = store.state.uiLanguageList

    responseData.forEach((responseItem: CompetenceResponseItem) => {
      if (responseItem.SpracheID !== null) {
        if (!result.has(responseItem.CompetenceID)) {
          result.set(responseItem.CompetenceID, [responseItem])
        } else {
          result.get(responseItem.CompetenceID)!.push(responseItem)
        }
      }
    })

    result.forEach((responseItemArray: Array<CompetenceResponseItem>) => {
      let dataMap: Map<string, CompetenceItem> = new Map()
      responseItemArray.forEach((responseItem: CompetenceResponseItem) => {
        const languageItem = languageList.find((languageItem: UiLanguageItem) => languageItem.syzId === responseItem.SpracheID)
        if (languageItem) {
          let row: CompetenceItem = {
            id: responseItem.CompetenceID,
            code: responseItem.CompetenceCode,
            description: responseItem.CompetenceBezeichnung
          }
          dataMap.set(languageItem.code, row)
        }
      })
      competenceList.push(new Competence(dataMap))
    })
    return competenceList
  }
}